export default "__VITE_PUBLIC_ASSET__34758cf4__"